import { FC, useMemo } from "react";
import { VoiceSelectModal } from "../../voiceAi/VoiceSelectModal";
import { useDigitalHumanVoiceLists } from "../useDigitalHumanVoiceLists";

/**
 * 数字人音色选择：弹窗复用 AI 音频页，公共/我的音色都走音色库（与口播接口一致）。
 * 列表按页增量加载，滚到底自动拉下一批；选中态按 id 匹配，避免同名音色选错。
 */
export const VoicePickerModal: FC<{
  valueId?: number | null;
  onClose: () => void;
  onConfirm: (voice: { id: number; name: string; source: "public" | "mine" }) => void;
}> = ({ valueId, onClose, onConfirm }) => {
  const {
    publicVoices,
    mineVoices,
    allVoices,
    publicLoading,
    mineLoading,
    hasMorePublic,
    hasMoreMine,
    loadMorePublic,
    loadMoreMine,
    setPublicKeyword,
    setMineKeyword,
  } = useDigitalHumanVoiceLists();

  const selectedIds = useMemo(
    () => (valueId ? [valueId] : []),
    [valueId]
  );

  return (
    <VoiceSelectModal
      open
      title="音色选择"
      subtitle="选择 1 个音色用于当前口播作品"
      maxCount={1}
      selectedIds={selectedIds}
      publicVoices={publicVoices}
      mineVoices={mineVoices}
      mineVoicesLoading={mineLoading}
      onMineKeywordChange={setMineKeyword}
      onPublicKeywordChange={setPublicKeyword}
      onLoadMore={(tab) => {
        if (tab === "public") loadMorePublic();
        else loadMoreMine();
      }}
      hasMore={{ public: hasMorePublic, mine: hasMoreMine }}
      loadingMore={{ public: publicLoading, mine: mineLoading }}
      onClose={onClose}
      onConfirm={(_ids, voices) => {
        if (!voices[0]) {
          onClose();
          return;
        }
        const picked = voices[0];
        const found = allVoices.find((v) => v.id === picked.id) ?? picked;
        onConfirm({
          id: picked.id,
          name: found.name,
          source: found.source,
        });
      }}
    />
  );
};
